<script generic="T" lang="ts" setup>
import { VButton } from '@shared/component/VButton';
import VButtonGroup from '@shared/component/VButtonGroup/VButtonGroup.vue';
import { VTooltip } from '@shared/component/VTooltip';
import { type InputOption } from '../types';

const props = defineProps<{
  hasError?: boolean;
  isDisabled?: boolean;
  isReadonly?: boolean;
  modelValue?: T;
  options: InputOption<T>[];
}>();

const emit = defineEmits<{
  'update:modelValue': [T];
}>();
</script>

<template>
  <VButtonGroup v-if="!props.isReadonly" attached>
    <VTooltip
      v-for="({ disabled, label, value, description }, i) in props.options"
      :key="i"
      :active="!!description"
      :label="description"
    >
      <VButton
        :disabled="props.isDisabled || disabled"
        :inverted="value !== props.modelValue"
        :type="props.hasError ? 'danger' : 'primary'"
        @click="emit('update:modelValue', value as T)"
      >
        {{ label }}
      </VButton>
    </VTooltip>
  </VButtonGroup>

  <template v-else>
    {{ props.options.find(({ value }) => value === props.modelValue)?.label || '-' }}
  </template>
</template>
